module.exports = __webpack_public_path__ + "img/banner-1.d0bc43bf.png";